const generateForm09 = [
  {
    label: "คำนำหน้า (ภาษาอังกฤษ)",
    name: "title_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ชื่อ (ภาษาอังกฤษ)",
    name: "first_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "นามสกุล (ภาษาอังกฤษ)",
    name: "last_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ฉายา (ภาษาอังกฤษ)",
    name: "buddhist_name_en",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "information",
  },
  {
    label: "ข้อมูลการปฏิบัติศาสนกิจ",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },

  {
    label: "ปัจจุบันปฏิบัติศาสนกิจอยู่ ณ",
    name: "organization",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 8 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ประเทศ",
    name: "country",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ตำแหน่ง",
    name: "position",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 9 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "ตั้งแต่วันที่",
    name: "since_date",
    placeholder: "",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "จำนวนครั้งที่ได้รับอนุญาตให้ไปปฏิบัติงานติดต่อกัน",
    name: "work_permit_amonth",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "รวมระยะเวลาติดต่อกันมาแล้ว (ปี)",
    name: "total_consecutive_period_year",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },
  {
    label: "รวมระยะเวลาติดต่อกันมาแล้ว (เดือน)",
    name: "total_consecutive_period_month",
    placeholder: "",
    type: "input",
    typeForm: "number",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },

  {
    label: "",
    name: "time_work_permit",
    placeholder: "",
    type: "input-array-period",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "operational_data",
  },

  {
    label: "สถานที่ติดต่อปัจจุบัน",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "ชื่อวัดหรือสำนักสงฆ์",
    name: "temple_name",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "บ้านเลขที่",
    name: "house_no",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 2 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "ถนน",
    name: "street",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 4 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "หมู่บ้าน/อาคาร",
    name: "village",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "ประเทศ",
    name: "country",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "จังหวัด/รัฐ",
    name: "province",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "เขต/อำเภอ",
    name: "district",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "แขวง/ตำบล",
    name: "district_sub",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },
  {
    label: "รหัสไปรษณีย์",
    name: "postcode",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "current_contact_address",
  },

  {
    label: "ข้อมูลเกี่ยวกับการปฏิบัติศาสนกิจที่ขอต่อ",
    name: "",
    placeholder: "",
    type: "header",
    typeForm: "",
    optionName: "",
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "",
  },
  {
    label: "ขออยู่ปฏิบัติศาสนกิจ ณ",
    name: "organization_requesting_work",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "info_about_religious_continued",
  },
  {
    label: "ประเทศ",
    name: "country",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "info_about_religious_continued",
  },
  {
    label: "ตำแหน่ง",
    name: "position",
    placeholder: "",
    type: "input",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "info_about_religious_continued",
  },
  {
    label: "ตั้งแต่วันที่",
    name: "start_date",
    placeholder: "",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "info_about_religious_continued",
  },
  {
    label: "ถึงวันที่",
    name: "end_date",
    placeholder: "",
    type: "date",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 6, lg: 3 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "info_about_religious_continued",
  },

  {
    label: "เหตุผลความจำเป็นที่อยู่ปฏิบัติศาสนกิจต่อ",
    name: "reasons_necessity_continue",
    placeholder: "",
    type: "textarea",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "reason",
  },
  {
    label: "ประโยชน์ที่ทางมหาวิทยาลัยจะได้รับ",
    name: "benefit_university_receive",
    placeholder: "",
    type: "textarea",
    typeForm: "text",
    formSize: "small",
    optionName: "",
    isCheck: false,
    style: {},
    responsive: { sm: 12, md: 12, lg: 12 },
    isRequired: false,
    titleRequired: "",
    disable: false,
    section: "reason",
  },
];

export default generateForm09;
